module.exports = __webpack_public_path__ + "static/robedemariee-b1e6db1e4bfffbbcaf558683d2d14d8b.jpg";